<template>
  <div class="mobile-footer">
    <div class="mobile-footer__top">
      <div class="mobile-footer__info">
        <div class="mobile-footer__row">
          <i class="iconfont icon-daohangdizhi"></i>
          <span>浙江省湖州市东坡路1558号34号楼35号楼</span>
        </div>
        <div class="mobile-footer__row">
          <i class="iconfont icon-24gf-telephone"></i>
          <span>汪女士: 15968177119</span>
        </div>
        <div class="mobile-footer__row">
          <i class="iconfont icon-24gf-telephone"></i>
          <span>林先生: 13511269473</span>
        </div>
      </div>
      <div class="mobile-footer__qr">
        <div class="mobile-footer__qr-item">
          <div class="mobile-footer__qr-img _wechat"></div>
          <span>公众号</span>
        </div>
        <div class="mobile-footer__qr-item">
          <div class="mobile-footer__qr-img _video"></div>
          <span>视频号</span>
        </div>
      </div>
    </div>
    <div class="mobile-footer__btm">
      <p>Copyright &copy; MOS IOT Technology Zhejiang CO.,LTD</p>
      <p>
        <img src="/static/img/icon_zgw.png" alt="" />
        浙公网安备33059102000380号
      </p>
      <p class="mobile-footer__icp" @click="toGJ">浙ICP备2024058818号-1</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileFooter',
  methods: {
    toGJ() {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-footer {
  width: 100%;
  background: url('~@/assets/images/shouyefoot.jpg') no-repeat center;
  background-size: cover;
  color: $color-white;
  font-size: $font-body;
  padding: 0.32rem $page-padding 0.36rem;

  &__top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.24rem;
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.12rem;
    line-height: 1.5;

    i {
      margin-right: 0.08rem;
      flex-shrink: 0;
      margin-top: 0.02rem;
      font-size: $font-small;
    }

    span {
      word-break: break-all;
    }
  }

  &__qr {
    display: flex;
    flex-shrink: 0;
    margin-left: 0.2rem;
  }

  &__qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 0.16rem;

    span {
      font-size: $font-caption;
      margin-top: 0.08rem;
      white-space: nowrap;
    }
  }

  &__qr-img {
    width: 0.9rem;
    height: 0.9rem;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &._wechat {
      background-image: url('~@/assets/images/wechat.jpg');
    }

    &._video {
      background-image: url('~@/assets/images/video.jpg');
    }
  }

  &__btm {
    border-top: 0.01rem solid rgba(255, 255, 255, 0.2);
    padding-top: 0.2rem;
    text-align: center;

    p {
      margin-bottom: 0.06rem;
      line-height: 1.4;

      img {
        width: 0.16rem;
        height: 0.16rem;
        vertical-align: middle;
        margin-right: 0.04rem;
      }
    }
  }

  &__icp {
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MobileFooter.vue